(ns frontend.test.text.view
  (:require
    [ui.components.text.view :as text]
    [ui.editors.data-input :as data-input]))

(defn view
  []
  [:div
   {:class "w-full h-full max-h-screen oveflow-hidden overflow-y-scroll gap-3 flex bg-base-light text-base-light-text "}
   [text/h1 {} "H1 - heading 1"]
   [text/h2 "H2 - heading 2"]
   [text/p
    "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like)."]
   [text/label {} "Input label"
    [data-input/view
     {:data-type :data.type/text-simple
      :value     "sample input text"}]]

   ])
